import { Module } from "vuex";
import state, { AnnotationStateV2 } from "./state";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

const annotationV2Module: Module<AnnotationStateV2, any> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};

export default annotationV2Module;
